import type { PageIssuesBadgeFragment } from "../client/generated";
import { IssuesBadge } from "./IssuesBadge";

type Props = {
  fragment: PageIssuesBadgeFragment;
};

export function PageIssuesBadge({ fragment }: Props) {
  return <IssuesBadge count={fragment.issues.length} />;
}
